import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { MissionContractPayment, MissionLifecycle } from "@/gql"
import moment from "moment"

type PendingPaymentCardProps = {
  payment: MissionContractPayment
  missionLifecycle: MissionLifecycle
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingPaymentCard',
  props: {
    payment: null,
    missionLifecycle: null
  },
  setup(__props: any) {

const props = __props as {
  payment: MissionContractPayment
  missionLifecycle: MissionLifecycle
}



const dueDate = computed(() => {
  return props.payment.dueDate ? moment(props.payment.dueDate).format("Do MMMM, YYYY") : null
})

return { __sfc: true,props, dueDate }
}

})